import { render, staticRenderFns } from "./PurchaseOrderRequisitions.vue?vue&type=template&id=0afd5e62&"
import script from "./PurchaseOrderRequisitions.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderRequisitions.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderRequisitions.vue?vue&type=style&index=0&id=0afd5e62&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afd5e62')) {
      api.createRecord('0afd5e62', component.options)
    } else {
      api.reload('0afd5e62', component.options)
    }
    module.hot.accept("./PurchaseOrderRequisitions.vue?vue&type=template&id=0afd5e62&", function () {
      api.rerender('0afd5e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-order/components/PurchaseOrderRequisitions.vue"
export default component.exports